import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { OfficeNotFoundView } from 'angieslist-app-platform/lib/browser';
import App from '../../../app/browser/App';
import EditProfileView from './EditProfileView';

export default function createRoutes() {
  return (
    <Route component={App} path="/app/profile">
      <IndexRoute component={OfficeNotFoundView} />
      <Route
        path="/app/profile/:serviceProviderId"
        component={EditProfileView}
      />
      <Route
        path="/app/profile/:serviceProviderId/:page"
        component={EditProfileView}
      />
      <Route
        path="/app/profile/:serviceProviderId/:page/:section"
        component={EditProfileView}
      />
      <Route component={OfficeNotFoundView} path="*" />
    </Route>
  );
}



// WEBPACK FOOTER //
// ./src/modules/profile/browser/createRoutes.js